import { Divider, Flex, Grid } from "@aws-amplify/ui-react";

const OneValueChart = ({ value, legend, footer }) => (
  <Grid textAlign="center">
    <Flex style={styles.flex}>
      <h2 className="text-muted mb-0" style={styles.ellipsis}>
        {value}
      </h2>
      <b className="text-muted">{legend}</b>
    </Flex>
    <Divider className="m-1" />
    <span className="text-muted">{footer}</span>
  </Grid>
);

const styles = {
  ellipsis: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  flex: {
    gap: "5px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    alignItems: "flex-end",
    justifyContent: "center",
  },
};

export default OneValueChart;
